import theme from 'Visualization/theme';

export const rem = px => `${px / theme.baseFontSize}rem`;

// 51px is the height of the Navbar
export const fillHeight = 'height: calc(100vh - 51px)';
